import React from 'react'
import { Link } from 'gatsby'

import './scroll-spy-nav.css'

export const ScrollSpyNav = ({ scrolling, locPathname, languageList}) => (
    <div className="component-scrollspy-nav">
        <div className={`component-scrollspy-nav__inner ${scrolling ? `scroll--fixed scroll__responsive--nonfixed` : ''}`}>
            {languageList.map((lang, index) => (
                <Link key={index} to={lang.link} className={`block mb-15 bold text--dark decoration-none ${locPathname === lang.link || (locPathname === null && lang.link === '/hermetica/') ? 'is-current' : ''}`}>{lang.name}</Link>
            ))}
        </div>
    </div>
)